module.exports = __webpack_public_path__ + "assets/img/download-banner2.13fd9b9b.png";